import { useEffect, useRef, useState } from "react"
import { usePageNumberContext } from "./page-number-context"

export default function PageNumber() {
  const { register, getTotalPages } = usePageNumberContext()
  const [pageNumber, setPageNumber] = useState<number | null>(null)
  const didRegister = useRef(false)

  useEffect(() => {
    if (!didRegister.current) {
      const page = register()
      setPageNumber(page)
      didRegister.current = true
    }
  }, [register])

  if (pageNumber === null) return null

  const totalPages = getTotalPages()

  return (
    <div
      className="d-flex justify-content-center"
      style={{
        position: 'absolute',
        left: 0,
        right: 0,
        bottom: '9mm',
        fontSize: '12px',
        color: '#888',
        pointerEvents: 'none',
        zIndex: 1,
      }}
    >
      Page {pageNumber} of {totalPages}
    </div>
  )
}
